import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const REWARDS_CASHIER_REWARDS_PROGRAM = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'REWARDS_CASHIER_REWARDS_PROGRAM')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          pageParam: {
            number: 0,
            size: 100,
          },
        },
        endpoint: '/cgs/api/customerFrontend/cashier/myMerchant',
        requestAction: REWARDS_CASHIER_REWARDS_PROGRAM.INIT_REQUEST,
        successAction: REWARDS_CASHIER_REWARDS_PROGRAM.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [REWARDS_CASHIER_REWARDS_PROGRAM.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [REWARDS_CASHIER_REWARDS_PROGRAM.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'rewardsCashierRewardsProgram',
    reducerMap: {
      rewardsCashierRewardsProgramState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
